import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const SalesPortalCreateCrmActivityDocument = gql`
  mutation SalesPortalCreateCrmActivity(
    $chatUUID: uuid!
    $checkIn: CRMActivityCheckInInput!
    $note: CRMActivityNoteInput
    $reminder: CRMActivityReminderInput
  ) {
    createCrmActivity(
      chat_id: $chatUUID
      check_in: $checkIn
      note: $note
      reminder: $reminder
    ) {
      activity_id
    }
  }
`;
export type SalesPortalCreateCrmActivityMutationFn = Apollo.MutationFunction<
  Types.SalesPortalCreateCrmActivityMutation,
  Types.SalesPortalCreateCrmActivityMutationVariables
>;
export function useSalesPortalCreateCrmActivityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SalesPortalCreateCrmActivityMutation,
    Types.SalesPortalCreateCrmActivityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SalesPortalCreateCrmActivityMutation,
    Types.SalesPortalCreateCrmActivityMutationVariables
  >(SalesPortalCreateCrmActivityDocument, options);
}
export type SalesPortalCreateCrmActivityMutationHookResult = ReturnType<
  typeof useSalesPortalCreateCrmActivityMutation
>;
export type SalesPortalCreateCrmActivityMutationResult =
  Apollo.MutationResult<Types.SalesPortalCreateCrmActivityMutation>;
export type SalesPortalCreateCrmActivityMutationOptions =
  Apollo.BaseMutationOptions<
    Types.SalesPortalCreateCrmActivityMutation,
    Types.SalesPortalCreateCrmActivityMutationVariables
  >;
